import type { SubmitAllProposalsPayload } from '@/types/NegotiationType';
import { ContractStatus } from '@/types/StatusType';
import { rtkApi } from '../rtkApi';

export type FieldData = {
  value: string;
  status: string;
  subsetClauseStatus: string;
};

export type CreateNegotiationRequest = {
  contractId: string;
  offeredPrice: FieldData;
  EarnestMoney: FieldData;
  AppraisalContingency: FieldData;
  ClosingDate: FieldData;
  HomeInspection: FieldData;
  FinancingContingency: FieldData;
  postCloseOccupancy: FieldData;
  proposedBy: FieldData;
  NegotiationStatus: FieldData;
  Suggested: FieldData;
  Contingent: FieldData;
  additionalClauses?: { [key: string]: FieldData };
  _id?: string;
  timestamp?: string;
};

export type GetCounterProposalResponse = {
  message: string;
  negotiation?: CreateNegotiationRequest;
};

export const NegotiationApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    submitCounterProposal: builder.mutation<void, CreateNegotiationRequest>({
      query: ({ contractId, ...body }) => ({
        url: `/negotiation/${contractId}/create`,
        method: 'POST',
        data: body,
      }),
      invalidatesTags: (_response, _result, { contractId }) => [
        { type: 'Contract', id: contractId },
      ],
    }),
    getCounterProposal: builder.query<GetCounterProposalResponse, string>({
      query: (contractId) => ({
        url: `/negotiation/${contractId}/counter-offer`,
      }),
      providesTags: (_response, _error, contractId) => [
        { type: 'Contract', id: contractId },
      ],
    }),
    updateCounterProposal: builder.mutation<void, CreateNegotiationRequest>({
      query: ({ contractId, ...body }) => ({
        url: `/negotiation/${contractId}/update`,
        method: 'PUT',
        data: body,
      }),
    }),
    getAvailableNegotiations: builder.mutation<
      { availableNegotiations: string[] },
      string[]
    >({
      query: (contractIds) => ({
        url: `/negotiation/available-negotiation`,
        method: 'POST',
        data: { contractIds },
      }),
    }),
    getNegotiationHistory: builder.query<any, string>({
      query: (contractId) => ({
        url: `/negotiation/negotiation-history/${contractId}`,
      }),
      providesTags: (_response, _error, contractId) => [
        { type: 'Contract', id: contractId },
      ],
    }),
    NegotiationStatus: builder.mutation<
      { latestNegotiations: string[] },
      string
    >({
      query: (contractId) => ({
        url: `/negotiation/${contractId}/status`,
        method: 'GET',
      }),
    }),
  }),
});
export const {
  useSubmitCounterProposalMutation,
  useGetCounterProposalQuery,
  useUpdateCounterProposalMutation,
  useGetAvailableNegotiationsMutation,
  useGetNegotiationHistoryQuery,
  useNegotiationStatusMutation,
} = NegotiationApi;
